module.exports = __webpack_public_path__ + "img/_54A2297_t.4fa260b2.jpg";